var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-4 py-2" },
    [
      !_vm.error
        ? _c("b-table", {
            staticClass: "shx-table w-100",
            attrs: {
              busy: _vm.fetching,
              items: _vm.rows,
              fields: _vm.columns,
              hover: "",
              dark: "",
              fixed: "",
              small: "",
              "sort-icon-left": "",
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(movix_id)",
                  fn: function (data) {
                    return [
                      data.item.movix_id
                        ? _c("span", { staticClass: "badge badge-info" }, [
                            _vm._v(_vm._s(data.item.movix_id)),
                          ])
                        : _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v("—"),
                          ]),
                    ]
                  },
                },
                {
                  key: "cell(admissions)",
                  fn: function (data) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatInt(data.item.admissions))),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(real)",
                  fn: function (data) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            data.item.real !== undefined &&
                              data.item.real !== null
                              ? data.item.real + "%"
                              : "—"
                          )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "table-busy",
                  fn: function () {
                    return [_c("table-spinner")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1766369022
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "text-center text-muted py-3" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : !_vm.fetching && !_vm.rows.length
        ? _c("div", { staticClass: "text-center text-muted py-3" }, [
            _vm._v("No titles."),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }